import switchFunc from 'lib/function/switchFunc'
import LineCameraIcon from 'LuxKit/Icons/line/LineCameraIcon'
import LineChairWithAirplaneIcon from 'LuxKit/Icons/line/LineChairWithAirplaneIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineCrownIcon from 'LuxKit/Icons/line/LineCrownIcon'
import LineLuxuryEscapesMonogramIcon from 'LuxKit/Icons/line/LineLuxuryEscapesMonogramIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import type { ComponentProps } from 'react'
import React from 'react'

const getIcon = switchFunc<typeof SvgIcon, App.LoyaltyBenefitType>({
  airport_transfer: LineTaxiIcon,
  lounge_pass: LineChairWithAirplaneIcon,
  hotel_upgrade: LineCrownIcon,
  tour_exp_credit: LineCompassIcon,
  travelshoot_credit: LineCameraIcon,
  discounted_insurance: LineShieldCheckIcon,
}, LineLuxuryEscapesMonogramIcon)

interface Props extends ComponentProps<typeof SvgIcon> {
  benefitType: App.LoyaltyBenefitType
}

function LoyaltyBenefitIcon({ benefitType, ...rest }: Props) {
  const Icon = getIcon(benefitType)
  return <Icon {...rest} />
}

export default LoyaltyBenefitIcon
